// extracted by mini-css-extract-plugin
export var container = "_4p-0";
export var infoButton = "_4p-1";
export var label = "_4p-3";
export var labelExpanded = "_4p-4";
export var price = "_4p-5";
export var priceExpanded = "_4p-6";
export var title = "_4p-2";